<template>
  <v-row class="toolbar" align="center" v-if="item">
    <v-col cols="6">
      <v-menu top offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">
            Share deal
          </v-btn>
        </template>

        <share-menu />
      </v-menu>
    </v-col>
    <v-col cols="6"><v-btn :href="item.url" target="_blank">Check it out</v-btn></v-col>
  </v-row>
</template>

<script>
import ShareMenu from "@/components/ShareMenu";

export default {
  name: "ShareFooter",
  props: ["item"],
  components: { ShareMenu }
}
</script>

<style scoped lang="scss">
.toolbar {
  z-index: 999;
  height: 80px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  background-color: #f5f5f5;

  .col {
    padding-left: 20px;
    padding-right: 20px;

    .v-btn {
      width: 100%;
      background-color: #ffe500!important;
    }
  }
}
</style>